import { memo, useEffect } from "react";

import appConfig from "config/appConfig";
import { useNavigate } from "react-router-dom";

import useLocalStorage from "../../services/localStorage/localStorage";

export interface ErrorFallbackProps {
	error?: any;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = memo(({ error }) => {
	const { setWithExpiry, getWithExpiry } = useLocalStorage();

	const navigate = useNavigate();

	// Handles failed lazy loading of a JS/CSS chunk.
	useEffect(() => {
		const chunkFailedMessage = /Loading chunk [\d]+ failed/;
		const importModuleFailedMessage = /Importing a module script failed/;
		const invalidMimeTypeFailedMessage = /is not a valid JavaScript MIME type/;
		const dynamicImportMessage = /to fetch dynamically imported module/;

		if (
			(error?.message &&
				(chunkFailedMessage.test(error.message) ||
					importModuleFailedMessage.test(error.message) ||
					invalidMimeTypeFailedMessage.test(error.message))) ||
			dynamicImportMessage.test(error.message)
		) {
			if (!getWithExpiry("chunk_failed")) {
				setWithExpiry("chunk_failed", "true", 10000);
				window.location.reload();
			}
		}
	}, [error, getWithExpiry, setWithExpiry]);

	navigate(appConfig.CORE_URLS.HOME);

	return null;
	// return (
	// 	<div>
	// 		<p>Something went wrong.</p>
	// 		<pre>{error?.message}</pre>
	// 	</div>
	// );
});

export default ErrorFallback;
